import { SVGProps } from 'react';

const Share = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2v13M8 6l4-4 4 4M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
    />
  </svg>
);
export default Share;
